module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a5-8-e201e47bb45c883b50bc22bde448574d.jpg";